
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 14.625s.121.019.14-.353c1.21.353 2.633.603 2.633.603s.454.151.303-.303c-.151-.453-.392-.65-.392-.65l-2.381-1.266-.101-.252s.403-1.462.403-1.765c.202-.15.504-.403.504-.403s.05.202.152.202c.1 0 .353-.05.353-.05s.05-.051.05-.303c.05-.252.202-1.362.151-1.866.353 0 5.043-.353 5.043-.353s.353-.05.353-.353V7.06s.1-.201-.353-.252c-.454-.05-5.85-.857-5.85-.857S8.71.05 7.5 0C6.29.05 6.492 5.95 6.492 5.95s-5.396.908-5.85.958C.19 6.958.29 7.16.29 7.16v.454c0 .353.353.353.353.353s4.69.353 5.043.353c-.05.504.151 1.613.151 1.866.05.252.05.302.05.302s.253.05.353.05c.101 0 .152-.201.152-.201s.258.138.46.29c0 .302.46 1.78.46 1.78l-.08.23-2.504 1.38s-.152.202-.303.656.303.303.303.303 1.445-.399 2.655-.701c.016.269.118.35.118.35z"}})])
          )
        }
      }
    